import { render } from "./EditToken.vue?vue&type=template&id=8485ab26"
import script from "./EditToken.vue?vue&type=script&lang=js"
export * from "./EditToken.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__